const store = {
    namespaced: true,
    state() {
        return {
            myAnnouncements: [],
            myAnnouncementsAll: [],

            announcements: [],
            announcementsNoPagination: [],
            announcementsCount: 0,
            pages: {},
            minPrice: null,
            maxPrice: null,
            status: null,
        };
    },
    getters: {
        myAnnouncements: state => state.myAnnouncements,
        myAnnouncementsAll: state => state.myAnnouncementsAll,

        announcements: state => state.announcements,
        announcementsNoPagination: state => state.announcementsNoPagination,
        announcementsCount: state => state.announcementsCount,
        pages: state => state.pages,
        minPrice: state => state.minPrice,
        maxPrice: state => state.maxPrice,
        status: state => state.status,
    },
    mutations: {
        SET_MY_ANNOUNCEMENTS: (state, items) => (state.myAnnouncements = items),
        SET_MY_ANNOUNCEMENTS_ALL: (state, items) => (state.myAnnouncementsAll = items),

        SET_ANNOUNCEMENTS_COUNT: (state, items) => (state.announcementsCount = items),

        SET_ANNOUNCEMENTS: (state, items) => {
            state.announcements = items.map(announcement => ({
                ...announcement,
                is_deleted: false,
            }));
        },
        SET_ANNOUNCEMENTS_NO_PAGINATION: (state, items) => {
            state.announcementsNoPagination = items;
        },

        SET_PAGES: (state, items) => (state.pages = items),
        SET_IS_DELETED: (state, { slug, is_deleted }) => {
            const announcement = state.announcements.find(announcement => announcement.slug === slug);
            if (announcement) {
                announcement.is_deleted = is_deleted;
            }
        },
        SET_MIN_PRICE: (state, items) => (state.minPrice = items),
        SET_MAX_PRICE: (state, items) => (state.maxPrice = items),
        SET_STATUS: (state, items) => (state.status = items),
    },
    actions: {
        deleteAnnouncement: async function ({ commit }, data) {
            const res = await this.$axios({
                method: 'DELETE',
                url: `/api/adverts/${data.slug}/`,
            });
            if (res.status === 204) {
                commit('SET_IS_DELETED', { slug: data.slug, is_deleted: true });
            }
        },
        //
        fetchMyAnnouncements: async function ({ commit }, data) {
            let currentType = '';
            if (data?.type === 'active') currentType = '?is_active=True';
            if (data?.type === 'inactive') currentType = '?is_active=False&is_draft=False';
            if (data?.type === 'draft') currentType = '?is_draft=True';
            try {
                const res = await this.$axios({
                    method: 'GET',
                    url: `/api/my-adverts/${currentType}`,
                });
                commit('SET_MY_ANNOUNCEMENTS', res.data);
                if (!data?.isFilter) commit('SET_MY_ANNOUNCEMENTS_ALL', res.data);
            } catch (error) {
                console.dir(error);
            }
        },
        fetchAnnouncements: async function ({ commit, rootGetters }, data) {
            try {
                // Define default values for query parameters
                const defaultQueryData = {
                    ...data.queryData,
                    is_negotiable_price: data.queryData?.is_negotiable_price ?? 'True',
                    price_unit: data.queryData?.price_unit ?? 'EUR',
                    area_unit: data.queryData?.area_unit ?? 'ari',
                };
                const queryParams = new URLSearchParams(defaultQueryData);

                // Create the URL with query parameters
                // const url = `/general/v2/product${data?.queryData?.page ? `?page=${data?.queryData?.page}` : '?page=1'}${data?.queryData?.sort_by ? `&sort_by=${data?.queryData?.sort_by}` : ''}`;
                const url = `/general/v2/product`;
                // Fetch data

                const filters = [];

                if (data?.queryData?.category) {
                    filters.push({ categoryId: data?.queryData?.category.split(',').map(Number) });
                }

                if (rootGetters['announcements/minPrice'] && rootGetters['announcements/maxPrice']) {
                    if (!data?.queryData?.min_price || !data?.queryData?.max_price) {
                        filters.push({
                            price: [
                                !data?.queryData?.min_price
                                    ? rootGetters['announcements/minPrice']
                                    : Number(data?.queryData?.min_price),
                                !data?.queryData?.max_price
                                    ? rootGetters['announcements/maxPrice']
                                    : Number(data?.queryData?.max_price),
                            ],
                        });
                    } else {
                        filters.push({
                            price: [
                                !data?.queryData?.min_price
                                    ? rootGetters['announcements/minPrice']
                                    : Number(data?.queryData?.min_price),
                                !data?.queryData?.max_price
                                    ? rootGetters['announcements/maxPrice']
                                    : Number(data?.queryData?.max_price),
                            ],
                        });
                    }
                } else {
                    filters.push({
                        price: [
                            !data?.queryData?.min_price ? 0 : Number(data?.queryData?.min_price),
                            !data?.queryData?.max_price ? 999999999 : Number(data?.queryData?.max_price),
                        ],
                    });
                }

                if (data?.queryData?.type) {
                    filters.push({ fb_s: [Number(data?.queryData?.type)] });
                }

                const res = await this.$axios.get(url, {
                    params: {
                        page: data?.queryData?.page,
                        sortBy: data?.queryData?.sort_by,
                        filters: JSON.stringify(filters),
                    },
                });

                // Determine the number of results to commit based on isFirstLoad
                const { page_size } = data.queryData;
                const resultsLength = res?.data?.data?.products?.length;
                let numToRender = resultsLength;

                // using this block for handling with load more btn
                if (data.isFirstLoad && page_size / 2 < resultsLength) {
                    numToRender = page_size / 2;
                }

                // Commit data to the store
                commit('SET_STATUS', res.data?.filters?.status_filter);
                commit('SET_MIN_PRICE', Number(res.data?.default_min));
                commit('SET_MAX_PRICE', Number(res.data?.default_max));
                commit('SET_ANNOUNCEMENTS', res.data.data.products.slice(0, numToRender));
                commit('SET_PAGES', {
                    total_pages: Number(res.data.pages),
                    current: Number(res.data.page),
                    next: Number(res.data.page) === Number(res.data.pages) ? null : Number(res.data.page) + 1,
                    previous: Number(res.data.page) === 1 ? null : Number(res.data.page) - 1,
                });
                commit('SET_ANNOUNCEMENTS_COUNT', res.data.totalCount);

                // get all announcements without pagination only when we are not in profile page
                // only where we have layout map
                if (!['profile'].includes(data.pageName)) {
                    // for no pagination
                    const queryNoPagination = {
                        ...defaultQueryData,
                        page_size: res.data.count,
                    };
                    // const url1 = `/api/adverts/?${new URLSearchParams(queryNoPagination).toString()}`;
                    // const res1 = await this.$axios.get(url1);
                    // commit('SET_ANNOUNCEMENTS_NO_PAGINATION', res1.data.results);
                }

                // this function will return if announcements have been cutted
                return numToRender < resultsLength;
            } catch (error) {
                console.dir(error);
            }
        },
    },
};

export default store;
